import recommendationPreview1 from "../../offer/images/building3Dview.png";
import recommendationPreview3 from "../../offer/images/notification_box_image.jpg";
import recommendationPreview2 from "../../offer/images/presale_offer_default_img.jpg";

/** Channel CTA target required by RP-775. */
export const PERSONALIZED_HOMEPAGE_MISSION_CHANNEL_HREF = "https://www.youtube.com/@MisjaMieszkanie";

/** Featured Misja Mieszkanie episode — static until a feed API exists. */
export const PERSONALIZED_HOMEPAGE_MISSION_VIDEO_ID = "decFn3c4tAA";

export const PERSONALIZED_HOMEPAGE_MISSION_VIDEO_HREF = `https://www.youtube.com/watch?v=${PERSONALIZED_HOMEPAGE_MISSION_VIDEO_ID}`;

export const PERSONALIZED_HOMEPAGE_MISSION_THUMBNAIL = require("../images/mission_youtube_cover.png");

/**
 * Interim assets for the recommendations teaser. The RP-775 DoD wants the CTA
 * to launch the Homematch tinder mode, but its recommendations feed
 * (rp-auth/homematch: Prelead, TinderBufferRefiller) has no frontend contract
 * yet — until it ships, the teaser is derived from the user's own history in
 * `get_personalized_recommendations_teaser.ts` and these are its fallbacks.
 */
export const PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES = [recommendationPreview3, recommendationPreview2, recommendationPreview1];

export const PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE = "Nowa inwestycja";
import recommendationPreview1 from "../../offer/images/building3Dview.png";
import recommendationPreview3 from "../../offer/images/notification_box_image.jpg";
import recommendationPreview2 from "../../offer/images/presale_offer_default_img.jpg";

/** Channel CTA target required by RP-775. */
export const PERSONALIZED_HOMEPAGE_MISSION_CHANNEL_HREF = "https://www.youtube.com/@MisjaMieszkanie";

/** Featured Misja Mieszkanie episode — static until a feed API exists. */
export const PERSONALIZED_HOMEPAGE_MISSION_VIDEO_ID = "decFn3c4tAA";

export const PERSONALIZED_HOMEPAGE_MISSION_VIDEO_HREF = `https://www.youtube.com/watch?v=${PERSONALIZED_HOMEPAGE_MISSION_VIDEO_ID}`;

export const PERSONALIZED_HOMEPAGE_MISSION_THUMBNAIL = require("../images/mission_youtube_cover.png");

/**
 * Interim assets for the recommendations teaser. The RP-775 DoD wants the CTA
 * to launch the Homematch tinder mode, but its recommendations feed
 * (rp-auth/homematch: Prelead, TinderBufferRefiller) has no frontend contract
 * yet — until it ships, the teaser is derived from the user's own history in
 * `get_personalized_recommendations_teaser.ts` and these are its fallbacks.
 */
export const PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_IMAGES = [recommendationPreview3, recommendationPreview2, recommendationPreview1];

export const PERSONALIZED_HOMEPAGE_RECOMMENDATIONS_FALLBACK_BADGE = "Nowa inwestycja";
